import { Link, useNavigate } from "react-router-dom";
import { resolveImage } from "@/lib/image";
import {canOrderProduct} from "@/lib/productAvailability";

import {useShop} from "@/context/ShopContext";
import {Heart,Plus} from "lucide-react";
const BADGES = {
  demonstracao: {label:"Demonstração",cls:"bg-primary text-white"},
  novidade: { label: "Novidade", cls: "bg-green-600 text-white" },
  mais_vendido: { label: "Mais vendido", cls: "bg-secondary text-secondary-foreground" },
  ultimas_unidades: { label: "Últimas unidades", cls: "bg-destructive text-destructive-foreground" },
};

export default function ProductCard({ product, prioritizeImage=false }) {
  const {add,favorite,customer}=useShop();const navigate=useNavigate();
  const price = Number(product.price || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const badge = product.badge && BADGES[product.badge];
  return (
    <article className="relative flex flex-col"><Link
      to={`/produtos/${product.id}`}
      className="group bg-card border border-border rounded-xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition relative flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-square bg-muted overflow-hidden">
        {product.image_url ? (
          <img
            src={resolveImage(product.image_url)}
            alt={product.name}
            loading={prioritizeImage?"eager":"lazy"}
            fetchPriority={prioritizeImage?"high":"auto"}
            decoding="async"
            width="640" height="640"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-muted-foreground text-sm">Sem imagem</div>
        )}
        <div className="absolute top-2 left-2 flex flex-col gap-1 z-10">
          {badge && (
            <span className={`${badge.cls} text-[10px] uppercase font-bold px-2 py-1 rounded tracking-wider shadow`}>
              {badge.label}
            </span>
          )}
          {product.badge!=="demonstracao" && (!product.available || Number(product.stock)<Number(product.units_per_sale||1)) && (
            <span className="bg-foreground text-background text-[10px] uppercase font-bold px-2 py-1 rounded tracking-wider">
              Esgotado
            </span>
          )}
        </div>
      </div>
      <div className="p-3 sm:p-4 flex flex-col gap-1.5 flex-1">
        <span className="text-[10px] uppercase tracking-[0.15em] font-semibold text-muted-foreground">
          {product.category_slug?.replace(/-/g, " ")}
        </span>
        <h3 className="text-sm sm:text-base font-semibold text-foreground line-clamp-2 leading-snug min-h-[2.5rem]">
          {product.name}
        </h3>
        <div className="mt-auto pt-2 flex flex-wrap items-end justify-between gap-2">
          <div>
            <div className="text-[10px] uppercase text-muted-foreground">{Number(product.units_per_sale||1)===1?"1 peça":"Kit com "+Number(product.units_per_sale||1)+" peças"}</div>
            <div className="font-display font-bold text-2xl sm:text-3xl text-primary leading-none">R$ {price}</div>
          </div>
          <span className="text-[11px] font-display uppercase tracking-wider text-primary group-hover:underline">
            Ver detalhes →
          </span>
        </div>
      </div>
    </Link><div className="flex gap-2 pt-2"><button className="m20-btn flex-1 min-w-0 px-1 gap-1 text-[11px] sm:text-sm" aria-label={"Adicionar "+product.name} disabled={!canOrderProduct(product)} onClick={()=>add(product)}><Plus size={16} className="hidden sm:block shrink-0"/>Adicionar</button><button className="m20-icon-btn text-primary" aria-label={"Favoritar "+product.name} aria-pressed={customer?.favorites?.includes(product.id)||false} onClick={()=>favorite(product)}><Heart size={18} fill={customer?.favorites?.includes(product.id)?"currentColor":"none"}/></button></div><button className="min-h-11 text-sm font-bold bg-secondary text-primary rounded-xl mt-2 hover:brightness-95 transition disabled:opacity-40" disabled={!canOrderProduct(product)} onClick={()=>{if(add(product))navigate("/carrinho");}}>Comprar agora</button></article>
  );
}
